import React, { useState } from 'react';
import mixpanel from 'mixpanel-browser';
import { useSelector, useDispatch } from 'react-redux';

import { SearchSummary } from './SearchSummary';
import { FinanceRatesAndLenders } from './FinanceRatesAndLenders';

import { Footer } from '../../Footer/Footer';

import { signUpUserWithEmailForRates, sendEmailRates } from '../../../actions/usersActions';

import {
  MAKE,
  MODEL,
  YEAR,
  COLOR,
  AUTO_TYPE,
  MILEAGE,
  DOWN_PAYMENT,
  VEHICLE_PRICE,
  TRADE_IN_VALUE,
  LOAN_AMOUNT,
  HOME_PRICE,
  PROPERTY_TYPE,
  OCCUPANCY_TYPE,
  HOME,
  AUTO,
} from '../../../constants/ComparisonSummary';

export const ComparisonSummary = ({
  displayFooter = true,
  checkRates,
  isFullScreen,
  isRatesTableFullScreen = true,
  setIsFullScreen,
  user = null,
  usState = 'NY',
  tokenValue,
  vehicle = {},
}) => {
  const [isEmailRatesSubmitted, setIsEmailRatesSubmitted] = useState(false);
  const dispatch = useDispatch();
  const { financingType, ratesReducer, signUpError, ...vehOrPropertyProps } = useSelector(
    ({
      vehicleReducer: {
        auto_type,
        color,
        downPayment,
        estimateValue,
        financingType,
        make,
        mileage,
        model,
        selectedCreditTier,
        selectedLoanTerms,
        tradeInValue,
        year,
      },
      propertyReducer,
      ratesReducer,
      userReducer: { signUpError },
    }) => ({
      financingType: financingType || propertyReducer.financingType,
      [AUTO]: {
        [AUTO_TYPE]: auto_type,
        [COLOR]: color,
        [DOWN_PAYMENT]: downPayment,
        [VEHICLE_PRICE]: estimateValue,
        estimateValue,
        [MAKE]: make,
        [MILEAGE]: mileage,
        [MODEL]: model,
        selectedCreditTier,
        selectedLoanTerms,
        [TRADE_IN_VALUE]: tradeInValue,
        [YEAR]: year,
        [LOAN_AMOUNT]:
          (Number(estimateValue) || 0) - ((Number(downPayment) || 0) + (Number(tradeInValue) || 0)),
      },
      [HOME]: {
        [DOWN_PAYMENT]: propertyReducer.downPayment,
        [HOME_PRICE]: propertyReducer.estimateValue,
        estimateValue,
        [TRADE_IN_VALUE]: propertyReducer.tradeInValue,
        [PROPERTY_TYPE]: propertyReducer.propertyType,
        [OCCUPANCY_TYPE]: propertyReducer.occupancyType,
        [LOAN_AMOUNT]:
          (Number(propertyReducer.estimateValue) || 0) -
          ((Number(propertyReducer.downPayment) || 0) +
            (Number(propertyReducer.tradeInValue) || 0)),
        selectedLoanTerms: propertyReducer.mortgageTermInYears,
        selectedLoanTermInMonths: propertyReducer.mortgageTerm,
        selectedCreditTier,
      },
      ratesReducer,
      signUpError,
    }),
  );

  const handleEmailRates = (data) => {
    if (user?.email && user?.id) {
      dispatch(
        sendEmailRates({
          user,
          financingType,
          vehOrPropertyProps,
          usState,
          tokenValue,
        }),
      );
    } else {
      dispatch(
        signUpUserWithEmailForRates({
          user: {
            email: data.email,
            firstname: 'Anonymous',
            lastname: 'Anonymous',
            password: 'default_password',
          },
          financingType,
          vehOrPropertyProps,
          usState,
        }),
      );
    }
    setIsEmailRatesSubmitted(true);
    mixpanel.track(`Email Rates ${financingType}`, {});
  };

  return (
    <div>
      <SearchSummary
        isLoading={ratesReducer.loading}
        financingType={financingType}
        isFullScreen={isFullScreen}
        setIsFullScreen={setIsFullScreen}
        checkRates={checkRates}
        isEmailRatesSubmitted={isEmailRatesSubmitted}
        handleEmailRates={handleEmailRates}
        signUpError={signUpError}
        user={user}
        setIsEmailRatesSubmitted={setIsEmailRatesSubmitted}
        {...vehOrPropertyProps[financingType]}
        {...vehicle}
      />
      <FinanceRatesAndLenders
        isRatesTableFullScreen={isRatesTableFullScreen}
        isLoading={ratesReducer.loading}
        selectedLoanTerms={vehOrPropertyProps[financingType]?.selectedLoanTerms}
        financingType={financingType}
        selectedLoanTermInMonths={vehOrPropertyProps[financingType]?.selectedLoanTermInMonths}
        lenders={ratesReducer.lenders}
      />
      {displayFooter && (
        <div className="mobile-view-only">
          <Footer currentPath={'/rates'} />
        </div>
      )}
    </div>
  );
};
